<div class="documents-dialog">
    <mm-dialog-title [isUnderlined]="true">
        {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.DOWNLOAD_INVOICE_MODAL.TITLE' | translate }} - {{ data?.orderNumber }}
    </mm-dialog-title>

    <div class="documents-dialog__table-container">
        <table [dataSource]="data?.documents"
               [mmTestId]="'DOWNLOAD_DOCUMENTS.TABLE'"
               class="documents-dialog__table"
               [class.two-columns]="!data?.isCreditNotesVisible"
               mm-table>

            <ng-container mmColumnDef="products">
                <th [mmTestTarget]="'products-title'"
                    *mmHeaderCellDef
                    mmHeaderCell>
                    {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.DOWNLOAD_INVOICE_MODAL.PRODUCTS.TITLE' | translate }}
                </th>
                <td *mmCellDef="let element"
                    mmCell
                    [mmTestTarget]="'products-value'"
                    class="product-cell">
                    <div class="product-cell__item product-cell__item--title"
                         [mmTestTarget]="'shop-name'"
                         #shopRef
                         [mmTooltip]="fullShopName"
                         [mmTooltipDisabled]="!(shopRef.offsetWidth | isTruncatedByCss: shopRef.scrollWidth)">
                        {{ element?.products?.shopName }}
                    </div>
                    <ng-template #fullShopName>{{ element?.products?.shopName }}</ng-template>
                    <div *ngFor="let productItem of element?.products?.items; trackBy: trackByProduct"
                         class="product-cell__item"
                         [mmTestTarget]="'product-name'"
                         #nameRef
                         [mmTooltip]="fullProductName"
                         [mmTooltipDisabled]="!(nameRef.offsetWidth | isTruncatedByCss: nameRef.scrollWidth)">
                        {{ productItem?.product?.name }}
                        <ng-template #fullProductName>{{ productItem?.product?.name }}</ng-template>
                    </div>
                </td>
            </ng-container>

            <ng-container mmColumnDef="invoices">
                <th [mmTestTarget]="'invoices-title'"
                    *mmHeaderCellDef
                    mmHeaderCell>
                    {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.DOWNLOAD_INVOICE_MODAL.INVOICES.TITLE' | translate }}
                </th>
                <td [mmTestTarget]="'invoices-value'"
                    *mmCellDef="let element"
                    class="document-cell"
                    mmCell>
                    <ng-container *ngTemplateOutlet="documentCell; context: { documents: element?.invoices }">
                    </ng-container>
                </td>
            </ng-container>

            <ng-container mmColumnDef="creditNotes">
                <th [mmTestTarget]="'credit-notes-title'"
                    *mmHeaderCellDef
                    mmHeaderCell>
                    {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.DOWNLOAD_INVOICE_MODAL.CREDIT_NOTES.TITLE' | translate }}
                </th>
                <td [mmTestTarget]="'credit-notes-value'"
                    *mmCellDef="let element"
                    class="document-cell"
                    mmCell>
                    <ng-container *ngTemplateOutlet="documentCell; context: { documents: element?.creditNotes }">
                    </ng-container>
                </td>
            </ng-container>

            <tr *mmHeaderRowDef="displayedColumns; sticky: true"
                mm-header-row></tr>
            <tr *mmRowDef="let row; columns: displayedColumns;"
                mm-row></tr>
        </table>
    </div>
</div>

<ng-template #documentCell
             let-documents="documents">
    <ng-container *ngIf="documents?.length; else emptyStateTemplate">
        <div *ngFor="let documentArrayItem of documents; trackBy: trackByDocument; first as isFirstDocument"
             class="document-content"
             [class.document-content--first]="isFirstDocument"
             [mmTooltip]="fileProducts">
            <button class="document-content__action-btn"
                    [mmTestTarget]="'download-document-btn'"
                    (click)="downloadFile( documentArrayItem[0])">
                <mm-icon [isCurrentColor]="false"
                         name="download"
                         class="document-content__icon"></mm-icon>
                <span *ngFor="let namePart of (documentArrayItem[0]?.name | documentName); first as isPartBeforeExtension"
                      class="document-content__file-name"
                      [ngClass]="{ 'document-content__file-name--part-before-extension': isPartBeforeExtension }">
                    {{ namePart }}
                </span>
            </button>
            <div class="document-content__date"
                 [mmTestTarget]="'document-date'">
                {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.DOWNLOAD_INVOICE_MODAL.DATE.TEXT' | translate }}:
                {{ documentArrayItem[0]?.createdAt | date : dateFormat }}
            </div>
            <ng-template #fileProducts>
                <div *ngFor="let document of documentArrayItem">
                    {{ document?.productName }}
                </div>
            </ng-template>
        </div>
    </ng-container>
</ng-template>

<ng-template #emptyStateTemplate>
    <span class="document-content__empty-state">
        {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.DOWNLOAD_INVOICE_MODAL.NOT_PROVIDED.TEXT' | translate }}
    </span>
</ng-template>

